import {
  type CoreFiltersFrontendStateShape,
  type MapFrontendStateToQueryArgs,
} from '../core-state.types';

export const transformFrontendStateToQueryArgs = <
  F extends CoreFiltersFrontendStateShape,
>(
  frontendState: F,
): MapFrontendStateToQueryArgs<F> => {
  const queryArgs: Record<string, Record<string, unknown>> = {};
  for (const [dimension, attributes] of Object.entries(frontendState)) {
    queryArgs[dimension] = {};
    for (const [attribute, value] of Object.entries(attributes)) {
      if (value === null || value === undefined) continue;
      if (Array.isArray(value)) {
        queryArgs[dimension][attribute] = value.map((item) => item.id);
      } else {
        queryArgs[dimension][attribute] = value;
      }
    }
  }
  return queryArgs as MapFrontendStateToQueryArgs<F>;
};
